<template>
  <div class="view pa24">
    <el-form :model="serchParams" class="demo-form-inline" :inline="true">
      <el-row style="padding-top: 20px;">
        <el-form-item label="设备名称" label-width="100px" label-position="left" class="fromItem" prop="deviceName">
          <el-input v-model="serchParams.deviceName" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="设备标识" label-width="100px" label-position="left" class="fromItem" prop="handle">
          <el-input v-model="serchParams.handle" placeholder="请输入设备标识"></el-input>
        </el-form-item> -->
        <el-form-item label="设备IMEI号" label-width="100px" label-position="left" class="fromItem" prop="imei">
          <el-input v-model="serchParams.imei" placeholder="请输入设备号"></el-input>
        </el-form-item>
        <el-form-item label="经销商" label-width="100px" label-position="left" class="fromItem" prop="dealerId">
          <el-select v-model="serchParams.dealerId" placeholder="请选择经销商">
            <el-option v-for="(item, index) in dealerList" :key="index" :label="item.dealerName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-row>
    </el-form>
    <div style="display: flex; justify-content: space-between;">
      <div>
        <el-button type="primary" @click="handleAddDealer('add')" style="margin-right: 5px;"
          icon="el-icon-plus">添加设备</el-button>
        <el-button type="primary" @click="parameter()" style="margin-right: 5px;"
          icon="el-icon-setting">参数设置</el-button>
        <el-button type="primary" @click="recycle()" icon="el-icon-thumb">设备回收</el-button>
        <el-button type="primary" @click="triggerUpload()" icon="el-icon-download" v-if="phone==15811111111"
          style="margin-right: 5px;">设备码导出</el-button>
        <el-upload class="upload-demo" :action="impAction" :before-upload="beforeImp" ref="upload"
          :on-success="impSuccess" :limit="1" :on-exceed="handleExceed" :on-error="impError" :show-file-list="false">
        </el-upload>
        <el-button type="primary" @click="importDevice()" icon="el-icon-upload2"
          v-if="phone==16603403494">设备导入</el-button>
      </div>
      <el-button type="primary" @click="filter()" icon="el-icon-s-operation">列表筛选</el-button>
    </div>
    <commonTable :tableData="tableData" :total="total" :currentPage="pageNum" @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange">
      <template v-slot:table>
        <el-table-column v-if="filterParams.deviceName" prop="deviceName" align="center" label="设备名称" />
        <el-table-column v-if="filterParams.handle" prop="handle" align="center" label="工业标识" />
        <el-table-column v-if="filterParams.dealerName" prop="dealerName" align="center" label="经销商" />
        <el-table-column v-if="filterParams.deviceAddress" prop="deviceAddress" align="center" label="绑定区域" />
        <el-table-column v-if="filterParams.orderNo" prop="orderNo" align="center" label="绑定订单号" />
        <el-table-column v-if="filterParams.shipmentPlace" prop="shipmentPlace" align="center" label="发货地址" />
        <el-table-column v-if="filterParams.receiptPlace" prop="receiptPlace" align="center" label="收货地址" />
        <el-table-column v-if="filterParams.status" prop="status" align="center" label="窜货状态">
          <template #default="{ row }">
            <span v-if="row.status == 1">运输中</span>
            <span v-if="row.status == 2">正常</span>
            <span v-if="row.status == 3">疑似窜货</span>
          </template>
        </el-table-column>
        <el-table-column v-if="filterParams.operator" prop="operator" align="center" label="操作员" />
        <el-table-column v-if="filterParams.vbat" prop="vbat" align="center" label="设备电量(%)">
          <template #default="{ row }">
            <span>
              {{ calculateBatteryPercentage(row.vbat) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column v-if="filterParams.remainingDays" prop="remainingDays" align="center" label="待机时长(天)"
          width="120" /> <el-table-column v-if="filterParams.temp" prop="temp" align="center" label="设备温度" />
        <el-table-column v-if="filterParams.imei" prop="imei" align="center" label="设备IMEI号" />
        <el-table-column v-if="filterParams.iccid" prop="iccid" align="center" label="设备卡号" />
        <!-- 设备信号 -->
        <el-table-column v-if="filterParams.rsrp" prop="rsrp" align="center" label="设备信号">
          <template #default="{ row }">
            <span>{{ getSignalQuality(row.rsrp) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="filterParams.version" prop="version" align="center" label="设备版本号" />
        <el-table-column v-if="filterParams.frequency" prop="frequency" align="center" label="设备频率" />
        <el-table-column v-if="filterParams.isRecycle" prop="isRecycle" align="center" label="是否回收">
          <template #default="{ row }">
            <span v-if="row.isRecycle === 0">未回收</span>
            <span v-else-if="row.isRecycle === 1">已回收</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="receivingTime" align="center" label="最后接收时间" />
        <el-table-column v-if="filterParams.createTime" prop="createTime" align="center" label="创建时间" />
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editDevice(scope.row)">编辑</el-button>
            <el-button type="text" @click="deleteDevice(scope.row)">删除</el-button>
            <!-- 详情 -->
            <el-button type="text" @click="detail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <!-- 弹窗组件 -->
    <el-dialog title="设备详情" :visible.sync="dialogVisible" width="60%" :modal-append-to-body="false">
      <el-form v-if="selectedDevice" label-position="right" label-width="130px">
        <el-row :gutter="20">
          <!-- 动态渲染字段 -->
          <el-col :span="12" v-if="filterParams.deviceName">
            <el-form-item label="设备名称">
              <el-input v-model="selectedDevice.deviceName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="filterParams.handle">
            <el-form-item label="设备标识">
              <el-input v-model="selectedDevice.handle" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="filterParams.dealerName">
            <el-form-item label="经销商">
              <el-input v-model="selectedDevice.dealerName" readonly></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="filterParams.deviceAddress">
            <el-form-item label="绑定区域">
              <el-input v-model="selectedDevice.deviceAddress" readonly></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="filterParams.orderNo">
            <el-form-item label="订单号">
              <el-input v-model="selectedDevice.orderNo" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="filterParams.shipmentPlace">
            <el-form-item label="发货地址">
              <el-input v-model="selectedDevice.shipmentPlace" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="filterParams.receiptPlace">
            <el-form-item label="收货地址">
              <el-input v-model="selectedDevice.receiptPlace" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="filterParams.status">
            <el-form-item label="窜货状态">
              <el-input :value="formatStatus(selectedDevice.status)" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="filterParams.vbat">
            <el-form-item label="设备电量(%)">
              <el-input :value="calculateBatteryPercentage(selectedDevice.vbat)" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="filterParams.remainingDays">
            <el-form-item label="待机时长">
              <el-input v-model="selectedDevice.remainingDays" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="filterParams.operator">
            <el-form-item label="操作员">
              <el-input v-model="selectedDevice.operator" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="filterParams.temp">
            <el-form-item label="设备温度">
              <el-input v-model.number="selectedDevice.temp" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="filterParams.iccid">
            <el-form-item label="设备卡号">
              <el-input v-model="selectedDevice.iccid" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="filterParams.imei">
            <el-form-item label="设备IMEI号">
              <el-input v-model="selectedDevice.imei" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="filterParams.version">
            <el-form-item label="设备版本号">
              <el-input v-model="selectedDevice.version" readonly></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="filterParams.isRecycle">
            <el-form-item label="是否回收">
              <el-input :value="formatRecycleStatus(selectedDevice.isRecycle)" readonly></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="filterParams.createTime">
            <el-form-item label="创建时间">
              <el-input v-model="selectedDevice.createTime" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <AddDeviceDialog ref="addDealerDialog" @getList="getList"></AddDeviceDialog>
    <parameterDialog ref="parameterDialog"></parameterDialog>
    <recycleDialog ref="recycleDialog"></recycleDialog>
    <importDeviceDialog ref="importDeviceDialog"></importDeviceDialog>
    <filterDialog ref="filterDialog" @update-list="handleFilterUpdate"></filterDialog>
  </div>
</template>

<script>
  import AddDeviceDialog from './components/AddDeviceDialog'
  import parameterDialog from './components/parameterDialog'
  import recycleDialog from './components/recycleDialog'
  import importDeviceDialog from './components/importDeviceDialog'
  import filterDialog from './components/filterDialog'
  import commonTable from "@/components/common/commonTable";
  import { getDeviceList, delDevice, updateDeviceIsSuspect } from '@/api/gps.js'
  import { fetchDealList } from '@/api/companyManage.js'
  import { baseUrl } from "@/utils/index"

  export default {
    name: "dealerList",
    components: {
      commonTable,
      AddDeviceDialog,
      parameterDialog,
      recycleDialog,
      importDeviceDialog,
      filterDialog,
    },
    data() {
      return {
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        serchParams: {},
        dealerList: [],
        filterParams: {
          deviceName: true,
          handle: true,
          dealerName: true,
          deviceAddress: true,
          orderNo: true,
          shipmentPlace: true,
          receiptPlace: true,
          status: true,
          operator: true,
          vbat: true,
          temp: true,
          iccid: true,
          version: true,
          isRecycle: true,
          createTime: true,
          imei: true,
          frequency: true,
          rsrp: true,
          remainingDays: true,
        }, // 用于存储筛选条件
        deviceName: true,
        phone: null,
        impAction: '/api/gpsDevice/exportExcel',
        dialogVisible: false,
        selectedDevice: null, // 存储选中的设备数据
      };
    },
    created() {
      const fromStats = this.$route.query.fromStatistics;
      console.log('fromStats:', fromStats);
      console.log('this.$route.query:', this.$route.query.deviceStatus);
      if (fromStats) {
        // 如果来自统计页面，设置对应的状态筛选
        this.serchParams.status = this.$route.query.deviceStatus;
        console.log('this.serchParams.status:', this.serchParams.status);
      }
      this.getList(),
        this.getDealerList(),
        this.phone = JSON.parse(localStorage.getItem('info')).phone
    },
    methods: {
      getSignalQuality(rsrp) {
        if (rsrp >= -40 && rsrp <= -60) return '非常好';
        if (rsrp > -70 && rsrp <= -60) return '良好';
        if (rsrp > -80 && rsrp <= -70) return '一般';
        if (rsrp > -90 && rsrp <= -80) return '稍弱';
        if (rsrp > -100 && rsrp <= -90) return '较弱';
        if (rsrp >= -110 && rsrp <= -100) return '差';
        if (rsrp < -110) return '很差';
        return '未知'; // 默认返回未知
      },
      updateIsSuspect(id, value) {
        const params = {
          deviceId: id,
          isWarn: value
        };
        updateDeviceIsSuspect(params).then(res => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "预警状态更新成功",
            });
          } else {
            this.$message({
              type: "error",
              message: "预警状态更新失败",
            });
            // 回滚状态
            const targetRow = this.tableData.find(row => row.id === id);
            if (targetRow) {
              targetRow.isSuspect = value === '1' ? '0' : '1';
            }
          }
        }).catch(error => {
          this.$message({
            type: "error",
            message: "请求出错，请稍后重试",
          });
          // 回滚状态
          const targetRow = this.tableData.find(row => row.id === id);
          if (targetRow) {
            targetRow.isSuspect = value === '1' ? '0' : '1';
          }
        });
      },
      triggerUpload() {
        this.$refs.upload.$el.querySelector('input[type="file"]').click();
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      handleAddDealer(type, id) {
        this.$refs.addDealerDialog.openDialog(type, id)
      },
      parameter() {
        this.$refs.parameterDialog.openDialog()
      },
      recycle() {
        this.$refs.recycleDialog.openDialog()
      },
      importDevice() {
        this.$refs.importDeviceDialog.openDialog()
      },
      filter() {
        this.$refs.filterDialog.openDialog()
      },
      search() {
        this.pageNum = 1
        this.getList()
      },
      resetSearch() {
        this.serchParams.deviceName = ''
        this.serchParams.imei = ''
        this.serchParams.handle = ''
        this.serchParams.dealerId = ''
        this.serchParams.status = ''
        this.pageNum = 1
        this.getList()
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          type: 1,
          companyId: JSON.parse(localStorage.getItem('info')).companyId,
          deviceName: this.serchParams.deviceName,
          imei: this.serchParams.imei,
          handle: this.serchParams.handle,
          dealerId: this.serchParams.dealerId,
          status: this.serchParams.status
        }
        getDeviceList(params).then(res => {
          // 转换 isWarn 为字符串类型
          this.tableData = res.data.list.map(item => {
            item.isWarn = String(item.isWarn);
            return item;
          });
          this.total = res.data.total;
        });
      },
      editDevice(data) {
        this.$refs.addDealerDialog.openDialog('edit', data)
      },
      deleteDevice(data) {
        let params = {
          id: data.id
        }
        this.$confirm('此操作将永久删除该设备, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delDevice(JSON.stringify(params)).then(res => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      calculateBatteryPercentage(vbat) {
        if (vbat == 0) return "--";
        if (vbat == null) return "--";
        console.log("vabt", vbat);
        let v = vbat / 1000;
        const minVoltage = 3.600; // 最低电压
        const maxVoltage = 4.150; // 最高电压
        // 计算百分比
        if (v <= minVoltage) return 0;
        if (v >= maxVoltage) return 100;
        return Math.round(((v - minVoltage) / (maxVoltage - minVoltage)) * 100);
      },
      getDealerList() {
        let params = {
          companyId: JSON.parse(localStorage.getItem('info')).companyId,
          type: 2,
          pageSize: 9999,
        }
        fetchDealList(params).then(res => {
          console.log(res.data.list);
          if (res.data) {
            this.dealerList = res.data.list
          }
        })
      },
      handleFilterUpdate(params) {
        console.log(params);
        this.filterParams = params; // 更新筛选条件
        // 除了选中的  其他都为false
        Object.keys(this.filterParams).forEach(key => {
          if (!params[key]) {
            this.filterParams[key] = false;
          }
        });
        this.pageNum = 1; // 重置页码
        this.getList(); // 获取新的数据
      },


      impSuccess(response, file, fileList) {
        this.$refs.upload.clearFiles();
        this.$message.success('导入成功')
        const downloadUrl = response.data; // 根据实际情况调整
        console.log(downloadUrl);
        this.downloadFile(downloadUrl);
      },

      getFileName(name) {
        return name.substring(name.lastIndexOf(".")); //.txt
      },
      beforeImp(file) {
        // 限制上传类型      pdf、doc、docx、xls、xlsx、ppt、pptx
        const fileExtensions = this.getFileName(file.name) === '.xls' || this.getFileName(file
          .name) === '.xlsx'
        //限制的上限为100M
        const max100M = file.size / 1024 / 1024 < 10;
        if (!fileExtensions) {
          this.$message.error('上传文件类型只能是 xls、xlsx格式!');
        }
        if (!max100M) {
          this.$message.error('上传文件大小不能超过 10MB!');
        }
        return fileExtensions && max100M;
      },
      impError(err, file, fileList) {
        this.$message.error('文件上传失败');
        console.error('文件上传失败:', err);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件`);
      },
      downloadFile(url) {
        console.log(baseUrl);
        let urls = baseUrl + url
        const link = document.createElement('a');
        link.href = urls;
        console.log(url);
        link.style.display = 'none';
        link.download = '设备二维码.xlsx'; // 设置下载的文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      },
      detail(device) {
        this.selectedDevice = device; // 将当前设备数据赋值给 selectedDevice
        this.dialogVisible = true; // 显示弹窗
      },
      formatStatus(status) {
        switch (status) {
          case 1: return '运输中';
          case 2: return '正常';
          case 3: return '已窜货';
          default: return '--';
        }
      },
      formatRecycleStatus(isRecycle) {
        return isRecycle === 0 ? '未回收' : isRecycle === 1 ? '已回收' : '--';
      }
    }
  }
</script>

<style lang="scss" scoped>
  .upload-demo {
    display: none;
  }
</style>